<template>
  <div v-if="$buttonAuthority(allButton, 'list')">
    <div v-if="!isReply">
      <div class="search-class">
        <el-form
          :model="searchTxt"
          :inline="true"
          size="small"
          class="serarch-form"
          label-position="right"
          label-width="110px"
        >
          <el-form-item label="平台账号">
            <el-select
              v-model="searchTxt.accountId"
              clearable
              filterable
              multiple
              collapse-tags
              reserve-keyword
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in amazonAccountList"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮件主题">
            <el-input
              class="input-width"
              v-model="searchTxt.subject"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件人邮箱">
            <el-input
              class="input-width"
              v-model="searchTxt.recipients"
            ></el-input>
          </el-form-item>
          <el-form-item label="收件时间">
            <el-date-picker
              v-model="searchTxt.sendBeginTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
            -
            <el-date-picker
              v-model="searchTxt.sendEndTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="标签">
            <el-select
              v-model="searchTxt.labelConfigId"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in labelConfigList"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回复状态">
            <el-select
              v-model="searchTxt.isReply"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.isReply"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="邮件类型">
            <el-select
              v-model="searchTxt.emailType"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.EmailType"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回复时间">
            <el-date-picker
              v-model="searchTxt.replyBeginTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
            -
            <el-date-picker
              v-model="searchTxt.replyEndTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="发件人邮箱">
            <el-input class="input-width" v-model="searchTxt.sender"></el-input>
          </el-form-item>
          <el-form-item label="客服人员">
            <el-select
              v-model="searchTxt.userId"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.userList"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他邮件">
            <el-checkbox v-model="isCheck"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button
              style="margin-left: 50px"
              type="primary"
              @click="search()"
              icon="el-icon-search"
              >查找</el-button
            >
            <el-button @click="reset()" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="main-table">
        <div class="table-header" style="margin-top: 15px">
          <exportComment
            v-if="$buttonAuthority(allButton, 'export')"
            :url="'/amazon/message/export'"
            :param="exportObj"
            :fileName="'Amazon邮件列表_'"
            :requestType="'post'"
          ></exportComment>
          <el-button
            icon="el-icon-refresh-left"
            @click="emailSync"
            v-if="$buttonAuthority(allButton, 'emailSync')"
            >同步邮件</el-button
          >
        </div>
        <commonTable
          ref="multipleTable"
          type="selection"
          :loading="loading"
          :tableData="tableData"
          :tableLabel="tableLabel"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :pageSize="pagination.pageSize"
          :currentPage="pagination.page"
          :total="total"
          @handleSelectionChange="handleSelectionChange"
        ></commonTable>
      </div>
      <div v-if="isLog">
        <logLook
          :modelName="modelName"
          :logType="logType"
          :id="scope.id"
          @lookClick="isShowEdit"
        ></logLook>
      </div>
    </div>
    <div v-if="isReply">
      <replay
        :scope="scope"
        @isShowEdit="isShowEdit"
        @getList="getList"
        :isEmail="isEmail"
      ></replay>
    </div>
  </div>
</template>
<script>
/**
 * 亚马逊邮件列表页
 * 功能：多条件搜索（账号/主题/收件人/标签/回复状态/邮件类型/时间/客服等），支持导出、同步邮件、
 *       单条标记重要、批量标记已读/未读/已回复，点击进入邮件详情/回复页
 */
import { sortAtoZ } from "@/utils/index.js";
import {
  amazonEmailList,
  updateStatus,
  markMessageRead,
  markMessageReply,
  syncMailType,
} from "@/api/user";
import replay from "../components/replay";
import { getAmazonMailTitle } from "@/utils/tableLabel";
import router from "vue-router";
import { constantRouterMap } from "@/router";
import Layout from "@/components/layout";
export default {
  components: { replay },
  data() {
    return {
      modelName: "mail",
      logType: "addMemberMessage",
      // 列表加载状态
      loading: true,
      isshowhidden: false,
      // 是否首次加载（首次加载后生成列定义）
      isFirst: true,
      // 是否打开日志弹窗
      isLog: false,
      // 是否进入邮件详情/回复页
      isReply: false,
      // 是否打开更换客服弹窗
      isUpdata: false,
      // 是否为可操作邮件（详情页只读）
      isEmail: false,
      // 当前选中行数据
      scope: {},
      hiddenHeader: [],
      // 按钮权限列表
      allButton: [],
      // 邮件列表数据
      tableData: [],
      // 表格列定义
      tableLabel: [],
      titleMap: [],
      dropList: {},
      renderList: {},
      // 批量勾选的邮件数据
      dataList: [],
      scopeList: [],
      // 搜索条件
      searchTxt: {
        userId: "",
        accountId: "",
        subject: "",
        recipients: "",
        sender: "",
        sendBeginTime: "",
        sendEndTime: "",
        mailType: "",
        labelConfigId: "",
        isReply: "",
        isRead: "",
        emailType: "9",
        sender: "",
        replyBeginTime: "",
        replyEndTime: "",
        otherEmail: "",
      },
      // 是否勾选"其他邮件"搜索条件
      isCheck: false,
      // 分页参数
      pagination: {
        page: 1,
        pageSize: 10,
      },
      // 总条数
      total: 0,
      // 导出参数（勾选的邮件 id 列表）
      exportObj: {
        query: {
          idList: [],
        },
      },
    };
  },
  computed: {
    labelConfigList: {
      get() {
        return this.$store.getters.dropList.labelConfigList;
      },
    },
    amazonAccountList: {
      get() {
        const obj = this.$store.getters.dropList.amazonAccountList;
        if (obj) {
          return sortAtoZ(Object.values(obj), obj);
        }
      },
    },
  },
  activated() {
    // 页面激活时拉取下拉数据、按钮权限并加载列表
    this.$store.dispatch("getDropListTwo", [
      "labelConfigList",
      "amazonAccountList",
    ]);
    this.allButton = this.$getStorage(this.$route.name + "_button");
    if (this.$buttonAuthority(this.allButton, "list")) {
      Object.assign(this.pagination, this.searchTxt);
      this.getList();
    }
  },
  methods: {
    /** 基于公共列配置生成表格列定义（第 2 列替换为重要邮件星标列） */
    getTableLabel() {
      this.tableLabel = getAmazonMailTitle(this.dropList, this);
      let imporMail = {
        label: "重要邮件",
        param: "isImportant",
        align: "center",
        width: "90px",
        show: true,
        render: (h, param) => {
          let img = h("div", {
            class: param.row.isImportant == 1 ? "start" : "no-start",
            style: {
              fontSize: "20px",
            },
          });
          return [img];
        },
      };
      this.tableLabel.splice(1, 1, imporMail);
      this.loading = false;
    },
    // 标记为重要邮件
    singClick(row) {
      const status = row.isImportant === 1 ? 2 : 1;
      let param = {
        id: row.id,
        isImportant: status,
      };
      updateStatus(param).then((result) => {
        if (result.code == 200) {
          this.$message.success(result.msg);
          this.getList();
          this.$refs.multipleTable.clear();
        }
      });
    },
    // 邮件详情
    toReply(row) {
      this.scope = row;
      this.isReply = true;
      this.isEmail = false;

      // let newRoutes = {
      //   path: "/",
      //   component: Layout,
      //   name: "replay",
      //   meta: {
      //     title: row.subject,
      //     redirect: "/replay",
      //     keepAlive: true,
      //   },
      //   children: [
      //     {
      //       path: "/replay",
      //       name: "replay"+row.id,
      //       component: () => import("@/views/amazonemail/components/replay"),
      //       meta: {
      //         title: "亚马逊邮件详情："+row.subject,
      //         keepAlive: true,
      //       },
      //     },
      //   ],
      // };
      // let arr=[]
      // arr.push(newRoutes)
      // this.$router.addRoutes(arr);
      // // this.$router.push({ path: "/secondRouter" });
      // this.$router.push({
      //  name: "replay"+row.id,
      //   query: {
      //     name: row.subject,
      //   },
      // }); // 后期优化跳转打开tab选项卡
      // console.log(this.$router.options.routes);
    },
    // 批量回复 暂无
    batchReply() {
      if (this.dataList.length > 0) {
        this.isReply = true;
      } else {
        this.$message.warning("请选择回复对象");
      }
    },
    /** 查询亚马逊邮件列表 */
    getList() {
      this.loading = true;

      amazonEmailList(this.pagination).then((result) => {
        if (result.code == 200) {
          this.tableData = result.data.pageInfo.records;
          this.total = result.data.pageInfo.total;
          let label = result.data.renderList;
          this.dropList = result.data.dropList;
          // this.dropList.amazonAccountList = sortAtoZ(
          //   Object.values(this.dropList.amazonAccountList),
          //   this.dropList.amazonAccountList
          // );
          if (label == null) {
            this.renderList = {};
          } else {
            Object.assign(this.renderList, label);
          }
          if (this.isFirst) {
            this.getTableLabel();
          } else {
            this.loading = false;
          }
          this.$refs.multipleTable.clear();
        }
      });
    },
    /** 手动同步邮件 */
    emailSync() {
      syncMailType().then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg);
          this.getList();
        }
      });
    },
    /** 批量标记选中邮件为已回复 */
    batchIsReply() {
      if (this.dataList.length > 0) {
        let ids = this.dataList.map((item) => {
          return item.id;
        });
        let param = {
          ids: ids,
        };
        markMessageReply(param)
          .then((result) => {
            if (result.code == 200) {
              this.$message.success(result.msg);
              this.getList();
              this.$refs.multipleTable.clear();
            }
          })
          .catch((err) => {});
      }
    },
    /** 批量标记选中邮件为已读 */
    batchIsRead() {
      if (this.dataList.length > 0) {
        let ids = this.dataList.map((item) => {
          return item.id;
        });
        let param = {
          ids: ids,
          isRead: 1,
        };
        markMessageRead(param)
          .then((result) => {
            if (result.code == 200) {
              this.$message.success(result.msg);
              this.getList();
              this.$refs.multipleTable.clear();
            }
          })
          .catch((err) => {});
      }
    },
    /** 批量标记选中邮件为未读 */
    batchNoRead() {
      if (this.dataList.length > 0) {
        let ids = this.dataList.map((item) => {
          return item.id;
        });
        let param = {
          ids: ids,
          isRead: 0,
        };
        markMessageRead(param)
          .then((result) => {
            if (result.code == 200) {
              this.$message.success(result.msg);
              this.getList();
              this.$refs.multipleTable.clear();
            }
          })
          .catch((err) => {});
      }
    },
    /** 打开发送更换客服弹窗（ids 为选中邮件 id 集合） */
    changeCustomer() {
      if (this.dataList.length > 0) {
        let ids = this.dataList.map((item) => {
          return item.id;
        });
        this.scope.ids = ids;
        this.isUpdata = true;
      } else {
        this.$message.warning("请选择邮件");
      }
    },
    /** 关闭所有弹窗/详情页，回到列表 */
    isShowEdit() {
      this.isLog = false;
      this.isReply = false;
      this.isUpdata = false;
    },
    /** 分页大小变化时重新查询 */
    handleSizeChange(value) {
      this.pagination.pageSize = value;
      this.pagination.page = 1;
      this.getList();
    },
    /** 页码变化时重新查询 */
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.getList();
    },
    /** 勾选变化时记录选中的邮件并同步导出 id 列表 */
    handleSelectionChange(value) {
      this.dataList = value;
      this.exportObj.query.idList = value.map((item) => item.id);
    },
    /** 按搜索条件查询邮件列表（其他邮件勾选状态转 0/1） */
    search() {
      this.searchTxt.otherEmail = this.isCheck ? 1 : 0;
      Object.assign(this.pagination, this.searchTxt);
      this.pagination.accountId = this.pagination.accountId.toString();
      this.exportObj.query.idList = [];
      Object.assign(this.exportObj.query, this.pagination);
      this.isFirst = false;
      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      this.getList();
    },
    /** 清空搜索条件并重新查询 */
    reset() {
      this.$delectObj(this.searchTxt);
      this.$delectObj(this.pagination, [
        "userId",
        "accountId",
        "subject",
        "recipients",
        "sender",
        "sendBeginTime",
        "sendEndTime",
        "mailType",
        "labelConfigId",
        "isReply",
        "isRead",
        "emailType ",
        "sender",
        "replyBeginTime",
        "replyEndTime",
        "otherEmail",
      ]);
      this.isFirst = false;
      this.isCheck = false;
      this.exportObj.query = this.searchTxt;
      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      this.getList();
    },
  },
};
</script>

<style scoped></style>
